var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "filter-option-element" },
    [
      _vm._l(_vm.getPrettySelectedOption, function (tag, index) {
        return _c(
          "div",
          {
            key: tag,
            staticClass: "table-browser-dropdown-selected-options",
            style: _vm.customWidth,
          },
          [
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.removeSelectedOption(index)
                  },
                },
              },
              [_vm._v("x ")]
            ),
            _vm._v("\n        " + _vm._s(tag) + "\n    "),
          ]
        )
      }),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.metadataTypeSearch,
              expression: "metadataTypeSearch",
            },
          ],
          ref: "search-bar",
          staticClass: "form-control",
          attrs: { type: "text", placeholder: "Select options to filter" },
          domProps: { value: _vm.metadataTypeSearch },
          on: {
            click: function ($event) {
              _vm.isDropped = true
            },
            keypress: function ($event) {
              if (!$event.type.indexOf("key") && $event.keyCode !== 13)
                return null
              $event.preventDefault()
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.metadataTypeSearch = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("transition", { attrs: { name: "table-browser-slide" } }, [
            _vm.isDropped
              ? _c(
                  "ul",
                  {
                    staticClass:
                      "table-browser-dropdown-menu table-browser-fixed-dimension",
                  },
                  _vm._l(_vm.options, function (value) {
                    return _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isVisibleMetadataType(value[1]),
                            expression: "isVisibleMetadataType(value[1])",
                          },
                        ],
                        key: value[0],
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "table-browser-dropdown-option-margin-left",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mutableMultipleSelectedOptions,
                                  expression: "mutableMultipleSelectedOptions",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: value[0],
                                checked: Array.isArray(
                                  _vm.mutableMultipleSelectedOptions
                                )
                                  ? _vm._i(
                                      _vm.mutableMultipleSelectedOptions,
                                      value[0]
                                    ) > -1
                                  : _vm.mutableMultipleSelectedOptions,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a =
                                        _vm.mutableMultipleSelectedOptions,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = value[0],
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.mutableMultipleSelectedOptions =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.mutableMultipleSelectedOptions =
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.mutableMultipleSelectedOptions = $$c
                                    }
                                  },
                                  _vm.applyChanges,
                                ],
                                keypress: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    $event.keyCode !== 13
                                  )
                                    return null
                                  $event.preventDefault()
                                },
                              },
                            }),
                            _vm._v(
                              "\n\n                        " +
                                _vm._s(value[1]) +
                                "\n\n                        "
                            ),
                            value[2]
                              ? _c("i", {
                                  class: value[2],
                                  attrs: { title: "In progress" },
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }